import Navbar from "./components/Navbar/Navbar";
import Intro from "./components/Intro/Intro";
import Landing from "./components/Landing/Landing";

import "./App.css";

function App() {

  return (
    <div>
      <Navbar />
      <Intro/>
      <Landing/>

    </div>
  );
}

export default App;
